/**
 * Імена риб і прикмети виду, друга сотня: українська.
 *
 * Про склад файлу — див. species-world-ru.ts.
 *
 * ⚠️ ЗАПОЗИЧЕНІ ІМЕНА НЕ ПЕРЕКЛАДАЮТЬСЯ. «Воллай», «маскінонг», «барамунді»,
 * «арапайма» — саме так їх звуть українською; вигадувати «американський судак»
 * означало б збити з пантелику того, хто шукає знайоме слово.
 */
export const МИР_UK: Record<string, string> = {
  // ── Іберія та Італія ────────────────────────────────────────────────────
  'fish.iberian_barbel': 'іберійська марена',
  'fish.iberian_barbel_look':
    'Видовжена, оливково-бронзова, з чотирма вусами й нижнім ротом. Стоїть у ямах під перекатами.',
  'fish.comizo_barbel': 'марена-комиза',
  'fish.comizo_barbel_look':
    'Марена з довгим рилом і майже щучою пащею — єдина, що б’є малька. Тримається в глибині.',
  'fish.gitano_barbel': 'південноіберійська марена',
  'fish.gitano_barbel_look':
    'Дрібніша й темніша за родичок, бік у дрібних цятках. Виходить зграєю на прикормлену точку.',
  'fish.ebro_barbel': 'ебрська марена',
  'fish.ebro_barbel_look':
    'Щільна, золотаво-сіра, з товстими губами. Тягне за течією не гірше за сазана вдвічі важчого.',
  'fish.iberian_nase': 'іберійський підуст',
  'fish.iberian_nase_look':
    'Сріблястий, з темною спиною й нижнім поперечним ротом. Шкребе каміння на струмені зграєю.',
  'fish.iberian_chub': 'південноіберійський клень',
  'fish.iberian_chub_look':
    'Дрібніший за нашого кленя, з великою лускою й темною спинкою. Тримається під навислими кущами.',
  'fish.italian_barbel': 'італійська марена',
  'fish.italian_barbel_look':
    'Прогониста, з темною плямистою спиною й чотирма вусами. Лежить на перекатах приток По.',
  'fish.italian_chub': 'італійський клень',
  'fish.italian_chub_look':
    'Широколобий, сріблястий, з темною облямівкою луски. Бере поверху й б’ється біля самих ніг.',
  'fish.italian_roach': 'італійська плітка',
  'fish.italian_roach_look':
    'Дрібна, срібна, з жовтим оком. Стоїть щільною зграйкою в каналах Ломбардії.',
  'fish.italian_pike': 'італійська щука',
  'fish.italian_pike_look':
    'Південна щука: бік у дрібних світлих плямах замість жовтих смуг. Стоїть у старицях і озерах.',
  'fish.agone': 'агоне',
  'fish.agone_look':
    'Оселедець альпійських озер: вузький, срібний, з темною плямою за зябровою кришкою. Ходить у товщі.',

  // ── Балкани, Дунай і Межиріччя ──────────────────────────────────────────
  'fish.danube_shad': 'дунайський оселедець',
  'fish.danube_shad_look':
    'Сріблястий, з кілем на череві й рядом темних плям уздовж боку. Іде вгору Дунаєм у квітні.',
  'fish.softmouth_trout': 'мʼякорила форель',
  'fish.softmouth_trout_look':
    'Форель карстових річок з мʼяким випнутим рилом і дрібним темним крапом. Стоїть у прозорій воді.',
  'fish.dentex_trout': 'зубата форель',
  'fish.dentex_trout_look':
    'Хижа балканська форель із зубатою пащею й високим тілом. Бʼє верховодку біля поверхні плес.',
  'fish.ohrid_trout': 'охридська форель',
  'fish.ohrid_trout_look':
    'Срібляста форель Охридського озера в поодиноких чорних цятках. Тримається глибини цілий рік.',
  'fish.schraetzer': 'дунайський йорж',
  'fish.schraetzer_look':
    'Вузький смугастий йорж із видовженим рилом: уздовж боку йдуть темні лінії. Лежить на дні русла.',
  'fish.greek_catfish': 'грецький сом',
  'fish.greek_catfish_look':
    'Сом річок Епіру: коротший за нашого, з широкою головою й двома вусами. Стоїть у ямах під завалами.',
  'fish.tigris_barbel': 'тигрова марена',
  'fish.tigris_barbel_look':
    'Величезна марена Тигру і Євфрату зі щучим рилом. Пильнує рибку на дні глибоких плес.',
  'fish.shabut': 'шабут',
  'fish.shabut_look':
    'Високотіла золотава марена з товстими губами й великою лускою. Годується на дні теплих річок.',
  'fish.mesopotamian_catfish': 'месопотамський сом',
  'fish.mesopotamian_catfish_look':
    'Сом Тигру і Євфрату: тіло світліше за наше, у мармурових розводах. Лежить у глибоких ямах.',

  // ── Західна і Північна Європа ───────────────────────────────────────────
  'fish.blaufelchen': 'блауфельхен',
  'fish.blaufelchen_look':
    'Сиг Боденського озера зі синюватою спиною й дрібним ротом. Стоїть на великій глибині в товщі.',
  'fish.alpine_char': 'альпійська палія',
  'fish.alpine_char_look':
    'Голець гірських озер: темна спина, рожеві плями, біла облямівка нижніх плавців. Любить крижану глибину.',
  'fish.aquitanian_pike': 'аквітанська щука',
  'fish.aquitanian_pike_look':
    'Щука річок південного заходу Франції: дрібніша за звичайну, бік в оливкових розводах. Стоїть у засідці.',
  'fish.danube_roach': 'дунайська плітка',
  'fish.danube_roach_look':
    'Велика плітка з високим тілом і жовтогарячими плавцями. Ходить зграєю руслом Дунаю.',
  'fish.pearlfish': 'перлфіш',
  'fish.pearlfish_look':
    'Важка плітка передальпійських озер; на нерест бік вкривається перловим висипом. Стоїть на глибині.',
  'fish.minnow': 'гольян',
  'fish.minnow_look':
    'Крихітний, строкатий, з темними плямами вздовж боку; на нерест черевце багряне. Живе в струмках зграйкою.',
  'fish.brook_lamprey': 'струмкова мінога',
  'fish.brook_lamprey_look':
    'Дрібна мінога чистих струмків: змієподібна, без щелеп. Дорослою не годується зовсім.',
  'fish.mediterranean_barbel': 'південна марена',
  'fish.mediterranean_barbel_look':
    'Невелика марена з плямистим боком і помаранчевим хвостом. Стоїть на камʼянистих перекатах.',
  'fish.apron': 'апрон',
  'fish.apron_look':
    'Довгий валькуватий окунець Рони з темними перевʼязями. Притискається до дна на бистрині.',
  'fish.topmouth_gudgeon': 'амурський чебачок',
  'fish.topmouth_gudgeon_look':
    'Крихітний вселенець із верхнім ротом і темною смугою вздовж боку. Заполоняє тихі ставки.',
  'fish.peipus_whitefish': 'чудський сиг',
  'fish.peipus_whitefish_look':
    'Сиг Чудського озера: сріблястий, з прямим лобом і нижнім ротом. Годується біля дна на піску.',

  // ── Східна Європа, Кавказ, Середня Азія і Сибір ─────────────────────────
  'fish.amur_redfin': 'амурська білизна',
  'fish.amur_redfin_look':
    'Прогониста, срібна, з пласкою головою й малиновими плавцями. Бʼє малька на струмені.',
  'fish.mongolian_redfin': 'монгольський червонопер',
  'fish.mongolian_redfin_look':
    'Хижак Амуру із задертим ротом і червонуватими плавцями. Ганяє дрібноту в товщі проток.',
  'fish.balkhash_marinka': 'балхаська маринка',
  'fish.balkhash_marinka_look':
    'Темно-оливкова, валькувата, з двома парами вусиків і нижнім ротом. Годується на камʼянистому дні.',
  'fish.common_marinka': 'маринка',
  'fish.common_marinka_look':
    'Сріблясто-сіра риба гірських річок із товстими губами. Бере на впалу комаху біля самого струменя.',
  'fish.naked_osman': 'голий осман',
  'fish.naked_osman_look':
    'Майже без луски, темно-бурий, з вусиками біля нижнього рота. Тримається каміння Іссик-Куля.',
  'fish.altai_osman': 'алтайський осман',
  'fish.altai_osman_look':
    'Щільний, сіро-зелений, з великою головою. У гірських озерах стає хижаком і бʼє дрібноту.',
  'fish.khramulya': 'храмуля',
  'fish.khramulya_look':
    'Темна спина, срібний бік, нижній рот із роговою кромкою. Шкребе водорості з каміння.',
  'fish.bulatmai_barbel': 'булат-маї',
  'fish.bulatmai_barbel_look':
    'Велика марена Кури й Араксу, золотаво-сіра, з товстими губами. Ходить дном на течії.',
  'fish.pike_asp': 'лисач',
  'fish.pike_asp_look':
    'Щуковидна білизна Амудар’ї: видовжена, срібна, з пласкою головою. Ганяє дрібноту на розливах.',
  'fish.balkhash_perch': 'балхаський окунь',
  'fish.balkhash_perch_look':
    'Окунь без смуг: рівно-сірий, з колючим гребенем. Стоїть біля заростей і корчів Балхаша.',
  'fish.baikal_grayling': 'чорний байкальський харіус',
  'fish.baikal_grayling_look':
    'Темний, майже бузковий, з величезним вітрильним плавцем у плямах. Стоїть на камінні біля берега.',
  'fish.round_whitefish': 'валок',
  'fish.round_whitefish_look':
    'Сиг із круглим у перетині тілом і маленьким нижнім ротом. Лежить на галечному дні північних річок.',
  'fish.humpback_whitefish': 'сиг-пижʼян',
  'fish.humpback_whitefish_look':
    'Горбатий сиг із приплюснутою головою й нижнім ротом. Годується на дні сибірських річок.',
  'fish.brown_bullhead': 'карликовий сомик',
  'fish.brown_bullhead_look':
    'Бурий сомик із квадратним хвостом і вісьмома вусиками. Забиває дрібні ставки й бере цілий рік.',

  // ── Тихоокеанські лососі ────────────────────────────────────────────────
  'fish.chinook': 'чавича',
  'fish.chinook_look':
    'Найбільший тихоокеанський лосось: темна спина в чорних цятках, чорні ясна. Стоїть у ямах.',
  'fish.coho': 'кижуч',
  'fish.coho_look':
    'Яскраво-срібний, із широким хвостом; у річці бік наливається малиновим. Тримається струменя.',
  'fish.chum': 'кета',
  'fish.chum_look':
    'У річці вкривається бузковими смугами впоперек тіла, щелепи загинаються. Іде руслом на нерест.',
  'fish.pink_salmon': 'горбуша',
  'fish.pink_salmon_look':
    'Дрібний лосось із великими чорними плямами на хвості; у самця в річці виростає горб. Ходить масою.',
  'fish.masu': 'сима',
  'fish.masu_look':
    'Сріблястий лосось із рожевою смугою й темними плямами. Єдиний, що живе тільки в Азії.',
  'fish.sakhalin_taimen': 'сахалінський таймень',
  'fish.sakhalin_taimen_look':
    'Темна спина, червонуваті плавці, широка паща. Стоїть в устях і пониззі сахалінських річок.',

  // ── Східна Азія ─────────────────────────────────────────────────────────
  'fish.herabuna': 'херабуна',
  'fish.herabuna_look':
    'Високий плаский карась із довгим анальним плавцем. Годується в товщі, а не з дна.',
  'fish.ugui': 'угай',
  'fish.ugui_look':
    'Японський ялець: сріблястий, на нерест із трьома помаранчевими смугами вздовж боку. Ходить зграєю.',
  'fish.hasu': 'хасу',
  'fish.hasu_look':
    'Невеликий хижак із вигнутим ротом і синюватим полиском. Бʼє дрібноту біля поверхні озер.',
  'fish.wuchang_bream': 'уханський лящ',
  'fish.wuchang_bream_look':
    'Короткий високий лящ із прямою спиною й дрібною лускою. Тримається в товщі ставків і водосховищ.',
  'fish.chinese_culter': 'китайський верхогляд',
  'fish.chinese_culter_look':
    'Плаский, срібний, із задертим угору ротом і прямою спиною. Ганяє малька поверху.',
  'fish.barbel_steed': 'кінь-губар',
  'fish.barbel_steed_look':
    'Прогонистий, із довгим рилом, товстою губою й парою вусиків. Порпається на піщаному дні.',
  'fish.amur_wels': 'амурський сом',
  'fish.amur_wels_look':
    'Дрібніший за європейського, з чотирма вусами й плямистим боком. Лежить у тихих протоках під корчами.',
  'fish.biwa_catfish': 'бівський сом',
  'fish.biwa_catfish_look':
    'Великий сом озера Біва з широкою пащею й коротким тілом. Виходить на мілини надвечір.',
  'fish.mandarin_fish': 'ауха',
  'fish.mandarin_fish_look':
    'Плямистий окунь із колючим гребенем і мармуровим боком. Стоїть у засідці біля дна серед каміння.',
  'fish.leopard_mandarin': 'леопардова ауха',
  'fish.leopard_mandarin_look':
    'Дрібніша за звичайну ауху, бік у круглих темних плямах, наче в леопарда. Тримається гірських річок.',
  'fish.ayu': 'аю',
  'fish.ayu_look':
    'Струнка, прозоро-зелена, з жовтою плямою на зябровій кришці; пахне кавуном. Пасеться на камінні.',
  'fish.wakasagi': 'вакасагі',
  'fish.wakasagi_look':
    'Крихітна корюшка озер Японії: напівпрозора, зі срібною смугою. Стоїть зграєю в товщі.',
  'fish.iwana': 'івана',
  'fish.iwana_look':
    'Голець японських струмків: темна спина, білі цятки, помаранчеве черевце. Стоїть під камінням.',
  'fish.yamame': 'ямаме',
  'fish.yamame_look':
    'Річкова форма сими: темні овальні плями вздовж боку, червоні цятки. Живе в холодних струмках.',
  'fish.japanese_eel': 'японський вугор',
  'fish.japanese_eel_look':
    'Змієподібний, темно-сірий, зі світлим черевом і дрібними зябровими щілинами. Уночі виходить на мілини.',
  'fish.amur_sturgeon': 'амурський осетер',
  'fish.amur_sturgeon_look':
    'Осетер із гострим рилом і рядами кістяних жучок, темніший за російського. Ходить дном Амуру.',

  // ── Північна Америка ────────────────────────────────────────────────────
  'fish.walleye': 'воллай',
  'fish.walleye_look':
    'Судак Америки: каламутно-білі очі з полиском, ікла, білий кут хвоста. Працює дно по брівках.',
  'fish.yellow_perch': 'жовтий окунь',
  'fish.yellow_perch_look':
    'Яскраво-жовтий, із сімома темними смугами й помаранчевими черевними. Тримається щільною зграєю.',
  'fish.muskellunge': 'маскінонг',
  'fish.muskellunge_look':
    'Величезна щука зі світлим боком у темних смугах і роздвоєним хвостом. Стоїть у засідці біля трави.',
  'fish.black_crappie': 'чорний краппі',
  'fish.black_crappie_look':
    'Високий, сріблястий, у чорних цятках без ладу. Висить зграєю біля затоплених дерев.',
  'fish.bluegill': 'синьозябровий сонячник',
  'fish.bluegill_look':
    'Круглий, строкатий, із синім язичком на зябровій кришці. Товчеться біля трави й бере все підряд.',
  'fish.blue_catfish': 'блакитний сом',
  'fish.blue_catfish_look':
    'Сіро-блакитний, із прямим краєм анального плавця й роздвоєним хвостом. Тримає русло на течії.',
  'fish.flathead_catfish': 'пласкоголовий сом',
  'fish.flathead_catfish_look':
    'Приплюснута голова, випнута нижня щелепа, жовто-бурий бік. Пильнує в завалах.',
  'fish.american_lake_trout': 'озерна палія',
  'fish.american_lake_trout_look':
    'Великий голець Великих озер: темний, у світлих плямах, хвіст глибоко вирізаний. Стоїть на глибині.',
  'fish.brook_char': 'американська палія',
  'fish.brook_char_look':
    'Темна спина в мармурових розводах, червоні цятки в блакитних обідках, біла облямівка плавців.',
  'fish.striped_bass': 'смугастий лаврак',
  'fish.striped_bass_look':
    'Срібний, із сімома темними смугами вздовж боку. Ганяє зграї малька в товщі водосховищ.',
  'fish.longnose_gar': 'довгорилий панцирник',
  'fish.longnose_gar_look':
    'Довге тіло в кістяній броні й вузьке зубате рило вдвічі довше за голову. Висить біля поверхні.',
  'fish.alligator_gar': 'міссісіпський панцирник',
  'fish.alligator_gar_look':
    'Велетень у панцирі з ромбічних пластин, із короткою крокодилячою пащею у два ряди зубів.',
  'fish.lake_sturgeon': 'озерний осетер',
  'fish.lake_sturgeon_look':
    'Темний осетер із тупим рилом і великими жучками. Годується на дні глибоких озер і річок.',
  'fish.white_sturgeon': 'білий осетер',
  'fish.white_sturgeon_look':
    'Найбільша риба Північної Америки: сіро-біла, з чотирма вусиками біля широкого рота.',

  // ── Тропіки і Південна півкуля ──────────────────────────────────────────
  'fish.golden_mahseer': 'золотий махсир',
  'fish.golden_mahseer_look':
    'Золота луска з долоню, товсті губи й потужний хвіст. Стоїть у бурхливих ямах гімалайських річок.',
  'fish.rohu': 'роху',
  'fish.rohu_look':
    'Сріблясто-блакитний, з опуклим лобом і спрямованим униз ротом. Годується в товщі теплих річок.',
  'fish.siamese_carp': 'сіамський короп',
  'fish.siamese_carp_look':
    'Величезний високотілий короп із непомірно великою головою й крупною лускою. Ходить дном Меконгу.',
  'fish.goonch': 'гунч',
  'fish.goonch_look':
    'Приплюснутий сом із широкою пащею й довгими вусами, бік у темних плямах. Тримається за камінням.',
  'fish.wallago': 'валлаго',
  'fish.wallago_look':
    'Плаский сріблястий сом із величезною пащею до потилиці й двома вусами. Стоїть у засідці під берегом.',
  'fish.mekong_catfish': 'меконгський сом',
  'fish.mekong_catfish_look':
    'Велетень без вусів і майже без зубів, сіро-сталевий, із маленькими очима. Ходить у товщі Меконгу.',
  'fish.giant_pangasius': 'сіамський пангасіус',
  'fish.giant_pangasius_look':
    'Темний пангасіус із ниткоподібними видовженими плавцями й високим спинним гребенем.',
  'fish.redtail_catfish': 'червонохвостий сом',
  'fish.redtail_catfish_look':
    'Чорна спина, біла смуга вздовж боку і яскраво-червоний хвіст. Виходить на лови в темряві.',
  'fish.giant_snakehead': 'гігантський зміноголов',
  'fish.giant_snakehead_look':
    'Зміїна голова, довгий спинний плавець, бік у чорних смугах. Стереже червоний виводок мальків.',
  'fish.peacock_bass': 'павичевий окунь',
  'fish.peacock_bass_look':
    'Золотаво-зелений, із трьома темними перевʼязями й вічком на хвості. Бʼє малька біля корчів.',
  'fish.dorado': 'золотий дорадо',
  'fish.dorado_look':
    'Золота луска, червоний хвіст, тупа голова з кістяною пащею. Стрибає свічкою, наче лосось.',
  'fish.traira': 'траїра',
  'fish.traira_look':
    'Валькувата, бура, з широкою зубатою пащею. Лежить у засідці серед трави дрібних заводей.',
  'fish.tambaqui': 'тамбакі',
  'fish.tambaqui_look':
    'Високий, чорно-сірий, із зубами як у людини — дробить горіхи й насіння, що падають у воду.',
  'fish.tigerfish': 'тигрова риба',
  'fish.tigerfish_look':
    'Срібний бік у поздовжніх смугах та ікла, що стирчать назовні при закритій пащі.',
  'fish.goliath_tiger': 'голіафовий тигр',
  'fish.goliath_tiger_look':
    'Тигрова риба Конго на зріст із людину: тридцять два ікла й червоні плавці.',
  'fish.nile_perch': 'нільський окунь',
  'fish.nile_perch_look':
    'Срібно-оливковий, із горбатою спиною й жовтим оком. Стоїть біля глибоких брівок і скель.',
  'fish.barramundi': 'барамунді',
  'fish.barramundi_look':
    'Срібний, із увігнутим лобом і високим хвостом; око світиться рожевим. Ходить устями й річками.',
  'fish.murray_cod': 'мюррейська тріска',
  'fish.murray_cod_look':
    'Важка риба в зелених мармурових розводах, із широкою пащею. Живе під корчами десятиліттями.',
  'fish.arapaima': 'арапайма',
  'fish.arapaima_look':
    'Велетень у великій червоній лусці, дихає повітрям і з шумом спливає подихати раз на чверть години.',
};
